/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextView = core.serialization.object({
    sheetId: core.serialization.string(),
    hiddenColumns: core.serialization.list(core.serialization.string()),
    label: core.serialization.string().optional(),
});
